// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as LoginCmp$PorterinFeature from "./login/LoginCmp.mjs";
import * as SignupCmp$PorterinFeature from "./signup/SignupCmp.mjs";
import * as AuthLayout$PorterinFeature from "./common/AuthLayout.mjs";
import * as LoginCmpV2$PorterinFeature from "./login-flow-v2/login-v2/LoginCmpV2.mjs";
import * as SignupCmpV2$PorterinFeature from "./login-flow-v2/signup-v2/SignupCmpV2.mjs";
import * as OtpValidationCmp$PorterinFeature from "./otp-validation/OtpValidationCmp.mjs";
import * as AuthWrapperModuleScss from "../styles/AuthWrapper.module.scss";
import * as CustomerProfileCmp$PorterinFeature from "./profile/CustomerProfileCmp.mjs";
import * as OtpValidationCmpV2$PorterinFeature from "./login-flow-v2/otp-validation-v2/OtpValidationCmpV2.mjs";
import * as SignupReqSelectionCmp$PorterinFeature from "./requirement-type/SignupReqSelectionCmp.mjs";
import * as ConditionalRecaptchaProvider$PorterinFeature from "../../../../contexts/google-next-recaptcha/ConditionalRecaptchaProvider.mjs";

var styles = AuthWrapperModuleScss;

function AuthWrapperCmp(Props) {
  var is_modalOpt = Props.is_modal;
  var close_modal = Props.close_modal;
  var auth_state = Props.auth_state;
  var show_close_iconOpt = Props.show_close_icon;
  var prefill = Props.prefill;
  var is_change_number_cta_visiableOpt = Props.is_change_number_cta_visiable;
  var close_on_successOpt = Props.close_on_success;
  var is_modal = is_modalOpt !== undefined ? is_modalOpt : false;
  var show_close_icon = show_close_iconOpt !== undefined ? show_close_iconOpt : true;
  var is_change_number_cta_visiable = is_change_number_cta_visiableOpt !== undefined ? is_change_number_cta_visiableOpt : true;
  var close_on_success = close_on_successOpt !== undefined ? close_on_successOpt : true;
  var match = React.useState(function () {
        return auth_state;
      });
  var setAuthState = match[1];
  var authState = match[0];
  var match$1 = React.useState(function () {
        return prefill;
      });
  var form_prefill = match$1[0];
  var closeModal = function (param) {
    if (close_modal !== undefined) {
      return Curry._1(close_modal, undefined);
    }
    
  };
  var tmp;
  if (typeof authState === "number") {
    switch (authState) {
      case /* SignupScreen */0 :
          tmp = React.createElement(AuthLayout$PorterinFeature.make, {
                children: React.createElement(SignupCmp$PorterinFeature.make, {
                      set_auth_state: setAuthState,
                      prefill: prefill
                    }),
                show_header: false,
                is_modal: is_modal,
                close_modal: closeModal
              });
          break;
      case /* SignupReqSelection */1 :
          tmp = React.createElement(AuthLayout$PorterinFeature.make, {
                children: React.createElement(SignupReqSelectionCmp$PorterinFeature.make, {
                      set_auth_state: setAuthState
                    }),
                show_header: false,
                is_modal: is_modal,
                close_modal: closeModal
              });
          break;
      case /* OtpValidation */2 :
          tmp = React.createElement(AuthLayout$PorterinFeature.make, {
                children: React.createElement(OtpValidationCmp$PorterinFeature.make, {
                      set_auth_state: setAuthState,
                      close_modal: closeModal,
                      is_modal: is_modal,
                      is_change_number_cta_visiable: is_change_number_cta_visiable,
                      close_on_success: close_on_success
                    }),
                show_header: false,
                is_modal: is_modal,
                close_modal: closeModal
              });
          break;
      case /* Profile */3 :
          tmp = React.createElement(AuthLayout$PorterinFeature.make, {
                children: React.createElement(CustomerProfileCmp$PorterinFeature.make, {
                      close_modal: closeModal
                    }),
                show_header: false,
                is_modal: is_modal,
                close_modal: closeModal
              });
          break;
      case /* LoginScreenV2 */4 :
          tmp = React.createElement(AuthLayout$PorterinFeature.make, {
                children: React.createElement(LoginCmpV2$PorterinFeature.make, {
                      set_auth_state: setAuthState,
                      close_modal: closeModal,
                      prefill: form_prefill,
                      set_form_prefill: match$1[1]
                    }),
                show_header: false,
                is_modal: is_modal,
                close_modal: closeModal
              });
          break;
      case /* SignupScreenV2 */5 :
          tmp = React.createElement(AuthLayout$PorterinFeature.make, {
                children: React.createElement(SignupCmpV2$PorterinFeature.make, {
                      set_auth_state: setAuthState,
                      close_modal: closeModal,
                      prefill: form_prefill
                    }),
                show_header: false,
                is_modal: is_modal,
                close_modal: closeModal
              });
          break;
      case /* OtpValidationV2 */6 :
          tmp = React.createElement(AuthLayout$PorterinFeature.make, {
                children: React.createElement(OtpValidationCmpV2$PorterinFeature.make, {
                      set_auth_state: setAuthState,
                      close_modal: closeModal,
                      is_modal: is_modal
                    }),
                show_header: false,
                is_modal: is_modal,
                close_modal: closeModal
              });
          break;
      
    }
  } else {
    tmp = React.createElement(AuthLayout$PorterinFeature.make, {
          children: React.createElement(LoginCmp$PorterinFeature.make, {
                set_auth_state: setAuthState,
                close_modal: closeModal,
                show_close_icon: show_close_icon,
                login_form_state: {
                  login_form_input: authState._0,
                  is_disabled: authState._1
                }
              }),
          show_header: false,
          is_modal: is_modal,
          close_modal: closeModal
        });
  }
  return React.createElement(ConditionalRecaptchaProvider$PorterinFeature.make, {
              children: tmp
            });
}

var make = AuthWrapperCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
